import {ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  AbstractObjectDetailService,
  CodebookService,
  EntityInfoComponent,
  FindFunctionalPositionByIdPipe,
  isDocumentObject,
  isFileObject,
  isStorageUnitObject,
} from '|shared';
import {RegistryOfficeTransferState} from '|api/commons';
import {
  ApiFileService,
  ApiStorageUnitService,
  FileDto,
  RegistryOfficeTransferWithMainEntityInfoDto,
  StorageUnitDto
} from '|api/document';
import {forkJoin, Observable, of} from 'rxjs';
import {
  WaitingDirective,
  LabelComponent,
  LoadingIndicatorService,
  SectionComponent
} from '@icz/angular-essentials';
import {
  DatePickerComponent,
  FormAutocompleteComponent,
  FormFieldComponent,
  IczOption
} from '@icz/angular-form-elements';
import {AsyncPipe} from '@angular/common';
import {enumToOptions, namedDtoToOption} from '@icz/angular-application-core';


@Component({
  selector: 'icz-object-detail-preview-transfer-info-section',
  templateUrl: './object-detail-preview-transfer-info-section.component.html',
  styleUrls: ['./object-detail-preview-transfer-info-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionComponent, WaitingDirective, LabelComponent, EntityInfoComponent, AsyncPipe, FindFunctionalPositionByIdPipe, DatePickerComponent, FormAutocompleteComponent, FormFieldComponent]
})
export class ObjectDetailPreviewTransferInfoSectionComponent implements OnChanges {

  private codebookService = inject(CodebookService);
  private apiFileService = inject(ApiFileService);
  private apiStorageUnitService = inject(ApiStorageUnitService);
  private abstractObjectDetailService = inject(AbstractObjectDetailService);
  protected loadingService = inject(LoadingIndicatorService);

  @Input({ required: true })
  transferWithMainEntity!: RegistryOfficeTransferWithMainEntityInfoDto;

  registryOfficeOptions: IczOption[] = [];

  mainTransferEntity: Nullable<FileDto|StorageUnitDto>;

  registryOfficeTransferStateOptions = enumToOptions('registryOfficeTransferState', RegistryOfficeTransferState);

  get isOnMainRegistryOfficeTransferEntityDetail() {
    if (isDocumentObject(this.abstractObjectDetailService.object)) {
      return this.abstractObjectDetailService.objectId === this.transferWithMainEntity.mainTransferEntityDocumentId;
    }
    else if (isFileObject(this.abstractObjectDetailService.object)) {
      return this.abstractObjectDetailService.objectId === this.transferWithMainEntity.mainTransferEntityFileId;
    }
    else if (isStorageUnitObject(this.abstractObjectDetailService.object)) {
      return this.abstractObjectDetailService.objectId === this.transferWithMainEntity.mainTransferEntityStorageUnitId;
    }
    else {
      return false;
    }
  }

  get isHandedOverInsideFileOrStorageUnit() {
    return this.transferWithMainEntity?.mainTransferEntityFileId || this.transferWithMainEntity?.mainTransferEntityStorageUnitId;
  }

  get isMainTransferEntitySectionVisible() {
    return this.isHandedOverInsideFileOrStorageUnit && !this.isOnMainRegistryOfficeTransferEntityDetail;
  }

  ngOnChanges(changes: SimpleChanges<this>) {
    if (changes.transferWithMainEntity && this.transferWithMainEntity) {
      let mainTransferEntity$: Nullable<Observable<FileDto|StorageUnitDto>>;

      if (this.isMainTransferEntitySectionVisible) {
        if (this.transferWithMainEntity.mainTransferEntityFileId) {
          mainTransferEntity$ = this.apiFileService.fileFindFileWithObjectExistenceCheck({id: this.transferWithMainEntity.mainTransferEntityFileId});
        }
        else if (this.transferWithMainEntity.mainTransferEntityStorageUnitId) {
          mainTransferEntity$ = this.apiStorageUnitService.storageUnitFindById({id: this.transferWithMainEntity.mainTransferEntityStorageUnitId});
        }
      }

      this.loadingService.doLoading(
        forkJoin([
          mainTransferEntity$ ?? of(null),
          this.codebookService.registryOffices(),
        ]),
        this
      ).subscribe(([mainTransferEntity, registryOffices]) => {
        this.mainTransferEntity = mainTransferEntity;
        this.registryOfficeOptions = registryOffices.map(namedDtoToOption());
      });
    }
  }

}
